import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';

import { Button } from '@components/base';
import { LayoutEntityType } from '@models/Content';

import LayoutEntityConflictSection from './LayoutEntityConflictSection';
import LayoutEntityConflictWarning from './LayoutEntityConflictWarning';

export type LayoutEntityConflictDialogProps = {
  entityType: LayoutEntityType;
  onCancel: VoidFunction;
  onConfirmOverwrite: VoidFunction;
  onSaveCopy?: VoidFunction;
};

const LayoutEntityConflictDialog: FC<LayoutEntityConflictDialogProps> = ({
  entityType,
  onCancel,
  onConfirmOverwrite,
  onSaveCopy,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog fullWidth maxWidth='sm' onClose={onCancel} open>
      <DialogTitle>{t('layoutEntityConflict.title')}</DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <LayoutEntityConflictWarning entityType={entityType} />

          <LayoutEntityConflictSection
            context='save'
            entityType={entityType}
            handleSave={onConfirmOverwrite}
          />

          {onSaveCopy && (
            <LayoutEntityConflictSection
              context='saveCopy'
              entityType={entityType}
              handleSave={onSaveCopy}
            />
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>{t('cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LayoutEntityConflictDialog;
